/* Eigen variant-picker: zet het gekozen variant-id in het cart-formulier en
   werkt de prijs bij. Vervangt Horizon's variant-picker.

   Onmogelijke combinaties worden verborgen. Bij de bar sign paper/foam bestaat
   niet elke maat in elk materiaal: paper heeft 8x12 en 20x30 die foam niet
   heeft, foam heeft 16x20 die paper niet heeft. Zonder filter kon de klant
   Foam + 8x12 aanklikken; sync() vond dan geen variant, deed niets, en het
   formulier hield stilzwijgend de vorige variant vast. De klant zag een
   selectie die niet in het winkelwagentje terechtkwam.

   Het filteren gaat van links naar rechts: optie 1 bepaalt wat er in optie 2
   overblijft, en zo verder. Staat de huidige keuze niet meer tussen de
   mogelijke, dan springt hij naar de eerste die wel kan.

   Verbergen gebeurt met een inline style en niet met een class, zodat er geen
   CSS bij hoeft: de pillen staan op display:inline-flex en dat wint van het
   hidden-attribuut. */
(function () {
  'use strict';
  if (customElements.get('napkin-variant-picker')) return;

  function money(cents) {
    var currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
        style: 'currency', currency: currency
      }).format(cents / 100);
    } catch (e) {
      return '$' + (cents / 100).toFixed(2);
    }
  }

  class NapkinVariantPicker extends HTMLElement {
    connectedCallback() {
      try {
        this.index = JSON.parse(this.querySelector('[data-variant-index]').textContent);
      } catch (e) {
        this.index = {};
      }

      this.combos = Object.keys(this.index).map(function (key) { return key.split('~'); });

      this.form = document.getElementById(this.dataset.formId) ||
                  document.querySelector('form[action*="/cart/add"]');

      this.addEventListener('change', this.onChange.bind(this));
      this.filter();
      this.sync();
    }

    controls(position) {
      var select = this.querySelector('select[data-variant-option="' + position + '"]');
      if (select) return { type: 'select', node: select };
      var radios = this.querySelectorAll('input[data-variant-option="' + position + '"]');
      if (radios.length) return { type: 'radio', nodes: radios };
      return null;
    }

    currentValue(position) {
      var control = this.controls(position);
      if (!control) return '';
      if (control.type === 'select') return control.node.value;
      var checked = this.querySelector('input[data-variant-option="' + position + '"]:checked');
      return checked ? checked.value : '';
    }

    selection() {
      return [this.currentValue(1), this.currentValue(2), this.currentValue(3)].join('~');
    }

    /* Kan waarde v op positie p, gegeven de keuzes op de posities ervoor? */
    possible(position, value, chosen) {
      for (var i = 0; i < this.combos.length; i++) {
        var combo = this.combos[i];
        if (combo[position - 1] !== value) continue;
        var ok = true;
        for (var q = 1; q < position; q++) {
          if (chosen[q - 1] && combo[q - 1] !== chosen[q - 1]) { ok = false; break; }
        }
        if (ok) return true;
      }
      return false;
    }

    filter() {
      if (!this.combos.length) return;
      var chosen = [];

      for (var position = 1; position <= 3; position++) {
        var control = this.controls(position);
        if (!control) { chosen.push(''); continue; }

        var self = this;
        var current = this.currentValue(position);
        var firstOk = '';
        var currentOk = false;

        if (control.type === 'select') {
          Array.prototype.forEach.call(control.node.options, function (option) {
            if (option.value === '') return;
            var ok = self.possible(position, option.value, chosen);
            option.hidden = !ok;
            option.disabled = !ok;
            if (ok && !firstOk) firstOk = option.value;
            if (ok && option.value === current) currentOk = true;
          });
          if (!currentOk && firstOk) control.node.value = firstOk;
        } else {
          Array.prototype.forEach.call(control.nodes, function (radio) {
            var ok = self.possible(position, radio.value, chosen);
            var label = radio.nextElementSibling;
            radio.disabled = !ok;
            if (label) label.style.display = ok ? '' : 'none';
            if (ok && !firstOk) firstOk = radio.value;
            if (ok && radio.checked) currentOk = true;
          });
          if (!currentOk && firstOk) {
            var target = this.querySelector('input[data-variant-option="' + position + '"][value="' + firstOk.replace(/"/g, '\\"') + '"]');
            if (target) target.checked = true;
          }
        }

        chosen.push(this.currentValue(position));
      }
    }

    onChange() {
      this.filter();
      this.sync();
    }

    sync() {
      var combo = this.selection();
      var variant = this.index[combo];
      if (!variant) return;

      /* Zorg dat er een id-veld in het formulier staat. */
      var field = this.form ? this.form.querySelector('[name="id"]') : null;
      if (this.form && !field) {
        field = document.createElement('input');
        field.type = 'hidden';
        field.name = 'id';
        this.form.appendChild(field);
      }
      if (field && field.value !== String(variant.id)) {
        field.value = variant.id;
        field.dispatchEvent(new Event('change', { bubbles: true }));
      }

      document.querySelectorAll('[data-napkin-price]').forEach(function (node) {
        node.textContent = money(variant.price);
      });

      var count = this.quantityLabel();
      document.querySelectorAll('[data-napkin-price-count]').forEach(function (node) {
        node.textContent = count;
      });

      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url);

      document.dispatchEvent(new CustomEvent('variant:update', {
        bubbles: true,
        detail: { source: 'napkin-variant-picker', variantId: variant.id }
      }));
    }

    /* Het gekozen aantal, voor naast de prijs.

       Dit las eerder de waarde die het woord "napkin" bevatte. Daardoor werkte
       het alleen bij servetten: "50 napkins" wel, "8 plates" en "24 labels"
       niet, dus op borden en stickers bleef de teller leeg.

       De aantaloptie is de enige die als dropdown wordt getoond - dat regelt de
       instelling dropdown_options op het blok, die overal op "Quantity" staat.
       Zet je daar ooit een tweede optie bij, dan pakt dit de eerste dropdown en
       moet het onderscheid op naam. De terugval eronder vangt producten af waar
       het aantal wel als pil staat: een waarde die met een getal begint, maar
       geen maat is (die bevatten x of inch). */
    quantityLabel() {
      var select = this.querySelector('select[data-variant-option]');
      if (select && select.value) return select.value;

      var parts = this.selection().split('~');
      for (var i = 0; i < parts.length; i++) {
        var part = parts[i];
        if (!/^\s*\d/.test(part)) continue;
        if (/\bx\b|inch|×|oz/i.test(part)) continue;
        return part;
      }
      return '';
    }
  }

  customElements.define('napkin-variant-picker', NapkinVariantPicker);
})();
